import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import AppStateProvider from './global/state';
import { JobNotificationProvider } from './components/job-alert-system/JobNotificationContext';
import { Provider } from 'react-redux';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <AppStateProvider>
      <ChakraProvider>
        <JobNotificationProvider>
          <App />
        </JobNotificationProvider>
      </ChakraProvider>
    </AppStateProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals